
import React, { useState, useEffect } from 'react';
import { loadSpriteSheet } from '../helpers/SpriteUtil';

const FaceSelector = ({ spriteSheet, frameWidth, frameHeight, rows, cols, onChange, startFaceIndex }) => {
    const [sprites, setSprites] = useState([]);
    const [currentFace, setCurrentFace] = useState(startFaceIndex);

    useEffect(() => {
        loadSpriteSheet(spriteSheet, frameWidth, frameHeight, rows, cols).then((sprites) => {
            setSprites(sprites);
        });
    }, [spriteSheet, frameWidth, frameHeight, rows, cols]);

    const handleNext = () => {
        let newCurrent = (currentFace + 1) % sprites.length;
        
        setCurrentFace(newCurrent);
        if (onChange)
        {
            onChange(newCurrent);
        }
    };

    const handlePrev = () => {
        let newCurrent = (currentFace - 1 + sprites.length) % sprites.length;

        setCurrentFace(newCurrent);
        if (onChange)
        {
            onChange(newCurrent);
        }
    };

    return (
        <>
        <div className="faceselector">
            <button className="left" onClick={handlePrev}>&#60;&#60;</button>
            <div className="facecontainer" style={{ backgroundImage: `url(${sprites[currentFace]})` }}></div>

            <button className="right" onClick={handleNext}>&#62;&#62;</button>
            
        </div>
        </>
    );
};

export default FaceSelector;